var $f61ea5933ac23d51$exports = {};
$f61ea5933ac23d51$exports = {
    "pending": `u tijeku`
};


export {$f61ea5933ac23d51$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
